export class TOSComputer {
    ID: number;
    MemberID: number;
    AdminID: number;
    DateTimeCreated: Date;
    Ignore: boolean;
    ComputerLogin: string;

    static FixDate(item: TOSComputer) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}


export class TOSComputerArray extends Array<TOSComputer>  {

    constructor(...items: TOSComputer[]) {
        super(...items);
        Object.setPrototypeOf(this, TOSComputerArray.prototype);
    }

    static FixDates(items: TOSComputerArray) {
        items.forEach(x => { TOSComputer.FixDate(x); });
    }

}


export class TOSMemberComputer {
    ID: number;
    MemberID: number;
    LicenseID: number;
    DateTimeCreated: Date;
    DateTimeWhitelisted: Date;
    IsWhitelisted: boolean;
    Name: string;

    static FixDate(item: TOSMemberComputer) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}


export class TOSMemberComputerArray extends Array<TOSMemberComputer>  {

    constructor(...items: TOSMemberComputer[]) {
        super(...items);
        Object.setPrototypeOf(this, TOSMemberComputerArray.prototype);
    }

    static FixDates(items: TOSMemberComputerArray) {
        items.forEach(x => { TOSMemberComputer.FixDate(x); });
    }

}
